@if(eudrAnmalan$ | async; as eudrAnmalan){
    <hr class="eudr-divider">
    <div class="mb-3">
        <div class="row">
            <div class="col-10 col-md-10">
                <rask-label class="eudr-label">Gällande</rask-label>
            </div>
            <div class="col-2 col-md-2 eudr-action-container">
                <rask-action-button
                    [disabled]="eudrAnmalan.loading"
                    (click)="onRetrieveClick()"
                    icon="far fa-sync-alt"
                ></rask-action-button>
            </div>
        </div>
        <rask-row>
            <div class="col-md-3">
                <rask-input
                    class="eudr-input"
                    label="ReferensNr"
                    [ngModel]="savedReferensnummer"
                    [readonly]="true"
                    placeholder="Inget sparat">
                </rask-input>
            </div>
            <div class="col-md-3">
                <rask-input
                class="eudr-input"
                    label="VerifieringsNr"
                    [ngModel]="savedVerifieringsnummer"
                    [readonly]="true"
                    placeholder="Inget sparat">
                </rask-input>
            </div>
            <div class="col-md-2">
                <rask-input
                class="eudr-input"
                    label="Status"
                    [ngModel]="savedStatus"
                    [readonly]="true"
                    placeholder="Inget sparat">
                </rask-input>
            </div>
            <div class="col-md-2">
                <rask-input
                class="eudr-input"
                    label="Skickad"
                    [ngModel]="savedSkickad | date: 'yyyy-MM-dd'"
                    [readonly]="true"
                    placeholder="Inget sparat">
                </rask-input>
            </div>
        </rask-row>
    </div>

    @if (eudrAnmalan.items.length > 0) {
        <rask-toggle-panel class="mt-3" label="Historik">
            <rask-list [data]="eudrAnmalan.items">
                <rask-list-column header="ReferensNr" field="referens"></rask-list-column>
                <rask-list-column header="VerifieringsNr" field="verifiering"></rask-list-column>
                <rask-list-column header="Status" field="status">
                    <ng-template let-row="row">
                        {{row.status}}
                        @if(row.errors?.length > 0){
                            <rask-icon
                                popoverClass="popover-error popover-no-max-width"
                                icon="error fal fa-info-circle">
                                <div class="popover-message-container">
                                    @for(error of row.errors; track error){
                                        <div class="popover-message" #message>
                                            {{error}}
                                        </div>
                                    }
                                </div>
                            </rask-icon>
                        }
                    </ng-template>
                </rask-list-column>
                <rask-list-column header="skickad" field="skickad">
                    <ng-template let-row="row">
                        {{row.skickad | date: 'yyyy-MM-dd' }}
                    </ng-template>
                </rask-list-column>
                <rask-list-column header="Kvitterad" field="kvitterad">
                    <ng-template let-row="row">
                        {{row.kvitterad | date: 'yyyy-MM-dd' }}
                    </ng-template>
                </rask-list-column>
            </rask-list>
        </rask-toggle-panel>
    }
}